export const specials = [
  {
    id: "sp-01",
    title: "深空纪元 · 科幻影像精选",
    subtitle: "从虫洞到星海，一次看遍想象力边界",
    intro:
      "当人类的脚步迈出地球，故事便有了更大的舞台。本专题收录太空冒险、时间旅行与奇幻探索题材作品，带你穿越想象力的边界。",
    reason: "适合喜欢硬核设定与宏大世界观的观众，一次补全科幻观影清单。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20dramatic%20deep%20space%20scene%20with%20a%20spaceship%20silhouette%20before%20a%20giant%20glowing%20wormhole%2C%20swirling%20nebula%20colors%2C%20cinematic%20atmosphere%2C%20epic%20lighting%2C%20ultra%20detailed%20sci-fi%20art&width=1200&height=675&seq=cnfilm-sp01-cover&orientation=landscape",
    workIds: ["m-01", "t-04", "m-06", "m-07"],
    groups: [
      { name: "太空史诗", workIds: ["m-01", "t-04"] },
      { name: "时间与命运", workIds: ["m-06"] },
      { name: "奇幻冒险", workIds: ["m-07"] },
    ],
  },
  {
    id: "sp-02",
    title: "华语古装权谋精选",
    subtitle: "宫墙之内，步步惊心",
    intro:
      "从庙堂之高到江湖之远，古装题材总能勾勒出人心的复杂。本专题精选权谋、宫廷与沙场故事，带你走进那个风起云涌的年代。",
    reason: "喜欢权谋博弈与群像叙事的观众不容错过。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20majestic%20ancient%20Chinese%20palace%20interior%20with%20red%20pillars%20and%20glowing%20lanterns%2C%20ink%20wash%20mountain%20backdrop%2C%20cinematic%20atmosphere%2C%20warm%20gold%20lighting%2C%20ultra%20detailed%20art&width=1200&height=675&seq=cnfilm-sp02-cover&orientation=landscape",
    workIds: ["t-01", "m-02", "m-05", "t-08"],
    groups: [
      { name: "权谋宫廷", workIds: ["t-01", "m-02"] },
      { name: "沙场风云", workIds: ["m-05"] },
      { name: "少年成长", workIds: ["t-08"] },
    ],
  },
  {
    id: "sp-03",
    title: "高分悬疑推理合集",
    subtitle: "真相，往往藏在最不起眼的细节里",
    intro:
      "一桩桩看似无关的案件，一条条被刻意掩埋的线索。本专题汇聚刑侦、心理与孤岛悬疑作品，让推理的快感层层递进。",
    reason: "适合偏爱反转与烧脑体验的推理爱好者。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20moody%20noir%20detective%20scene%20with%20a%20foggy%20street%20and%20a%20single%20streetlamp%2C%20long%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20ultra%20detailed%20art&width=1200&height=675&seq=cnfilm-sp03-cover&orientation=landscape",
    workIds: ["m-03", "t-03", "t-07", "m-02"],
    groups: [
      { name: "刑侦推理", workIds: ["t-03"] },
      { name: "心理惊悚", workIds: ["m-03", "t-07"] },
      { name: "古装迷案", workIds: ["m-02"] },
    ],
  },
  {
    id: "sp-04",
    title: "治愈味觉 · 美食影像特辑",
    subtitle: "人间烟火，最抚凡人心",
    intro:
      "食物从来不只是食物，它还承载着记忆、乡愁与坚持。本专题收录美食题材影像，用一道道家常的味道温暖你的夜晚。",
    reason: "深夜观看请自备夜宵，画面过于诱人。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20rustic%20wooden%20table%20filled%20with%20steaming%20colorful%20dishes%2C%20warm%20lantern%20light%2C%20cozy%20food%20photography%20atmosphere%2C%20rich%20colors%2C%20ultra%20detailed&width=1200&height=675&seq=cnfilm-sp04-cover&orientation=landscape",
    workIds: ["m-08", "v-02"],
    groups: [
      { name: "厨房传奇", workIds: ["m-08"] },
      { name: "街头风味", workIds: ["v-02"] },
    ],
  },
  {
    id: "sp-05",
    title: "音乐综艺狂欢夜",
    subtitle: "把烦恼调成静音，让现场开满音量",
    intro:
      "舞台灯光亮起的那一刻，所有情绪都会被点燃。本专题聚合音乐竞演与欢乐综艺，为你准备一场随时开场的热闹派对。",
    reason: "适合朋友聚会或独处解压，节奏轻快不伤脑。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20vibrant%20concert%20stage%20with%20colorful%20spotlights%20and%20laser%20beams%2C%20crowd%20silhouettes%2C%20energetic%20festival%20atmosphere%2C%20cinematic%20lighting%2C%20ultra%20detailed&width=1200&height=675&seq=cnfilm-sp05-cover&orientation=landscape",
    workIds: ["v-03", "v-08", "v-05", "v-01"],
    groups: [
      { name: "音乐现场", workIds: ["v-03", "v-08"] },
      { name: "欢乐综艺", workIds: ["v-05", "v-01"] },
    ],
  },
];